import React, { useState  as uState  } from 'react'
import { useNavigate as uNavigate } from 'react-router-dom'

import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'

export default function contact() {

  const navigate=uNavigate()
  const [contact, setContact] = uState({
    name: '',
    phone: '',
    email: '',
    medicine: '',
    message:'',
  })
  const handleContactChange = (event) => {
    setContact({
      ...contact,
      [event.target.name]:event.target.value
    })
  }

  const handleContactSubmit = async(e) => {
    if (contact.email === '' || contact.phone === '') {
      console.log('enter credentials first')
    }
    else {
      e.preventDefault()
      const response = await fetch('http://localhost:8000/contact/storeContact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: contact.name,
          phone: contact.phone,
          email: contact.email,
          medicine: contact.medicine,
          message: contact.message
        })
      })
      const json = await response.json()
      if (!json.success) {
        console.log('enter valid inputs')
      }
      else {
        
        navigate('/')
      }
    }
  }
  return (
    <>
      <Navbar/>
  <section className="contact_section ">
    <div className="container">
      <div className="row">
        <div className="custom_heading-container ">
          <h2>
            Request A call back
          </h2>
        </div>
      </div>
    </div>
    <div className="container layout_padding">
      <div className="row">
        <div className="col-md-5">
          <div className="form_contaier">
                <form onSubmit={handleContactSubmit}>
              <div className="form-group">
                <label htmlFor="exampleInputName1">Name</label>
                    <input required onChange={handleContactChange} name='name' value={contact.name} type="text" className="form-control" id="exampleInputName1" pattern="[A-Za-z\s]+" />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputNumber1">Phone Number</label>
                    <input required onChange={handleContactChange} name='phone' value={contact.phone} type="tel" className="form-control" id="exampleInputNumber1" pattern="[6-9]{1}[0-9]{9}" maxLength='10' minLength='10'/>
              </div>

              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Email </label>
                    <input required onChange={handleContactChange} name='email' value={contact.email} type="email" className="form-control" id="exampleInputEmail1" />
              </div>
              <div className="form-group ">
                <label htmlFor="inputState">Select medicine</label>
                    <select name='medicine' value={contact.medicine} onChange={handleContactChange} id="inputState" className="form-control">
                      <option>Select</option>
                      <option value='Parcetamol' >Parcetamol</option>
                      <option value='Calcix' >Calcix</option>
                      <option value='vitamin-B'>vitamin-B</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputMessage">Message</label>
                    <input required onChange={handleContactChange} name='message' value={contact.message} type="text" className="form-control" id="exampleInputMessage"/>
              </div>
                  <button  type="submit" className="">Send</button>
            </form>
          </div>
        </div>
        <div className="col-md-7">
          <div className="detail-box">
            <h3>
              Get Now Medicines
            </h3>
            <p>
              There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration
              in some form, by injected humour, or randomised words which don't look even slightly believable.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>    
    <Footer/>
    </>
  )
}
